/* eslint-disable max-len */
const filterPeriodos = (tipoNominaEmpleado, periodoFiscal, periodosNominas, periodosDetalles) => {
  const _periodosNominas = periodosNominas.filter((e) => e.tipo_de_nomina_empleado === tipoNominaEmpleado && e.periodo_fiscal === periodoFiscal);

  const _periodosDetallesFiltered = periodosDetalles.filter((e) => _periodosNominas.some((x) => x.id === e.periodo_de_nomina));

  return _periodosDetallesFiltered;
};

export default filterPeriodos;
